import Question from "./Question";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './QuestionList.module.scss'
import { shouldSkipQuestion } from '../logic/assessment';
import QuestionSubmitButton from './QuestionSubmitButton';
import { QuestionListItem } from './QuestionListItem';

type QuestionListType = {
    questions: any;
    answers: any;
    nextButton?: boolean;
    getUpdatedAnswers: Function
    reviewMode?: boolean
};

export const QuestionList = ({questions, answers, getUpdatedAnswers, nextButton = false, reviewMode = false}: QuestionListType )=> {
    const submitRef = useRef(null)
    const [updatedAnswers, setUpdatedAnswers] = useState(answers)

    // @ts-ignore
    const onChangeCallback = (key, value) => {
        // if(`${key}` in updatedAnswers) {
        const newAnswers = Object.assign({}, updatedAnswers)
        newAnswers[key] = value
        setUpdatedAnswers(newAnswers)
    }

    useMemo(() => {
        getUpdatedAnswers(updatedAnswers)
    }, [updatedAnswers])

    // @ts-ignore
    questions = questions.filter(question => (question.key !== 'ending' && question.key !== 'summary'))


    return <>
        <div className={styles.wrapper}>
        {questions.map(
            // @ts-ignore
            (question, index) => <QuestionListItem
                answers={answers}
                key={question.key}
                focus={index === 0}
                onChangeCallback={onChangeCallback}
                question={question}
                reviewMode={reviewMode}>
            </QuestionListItem>
            )
        }
            {
                nextButton && <QuestionSubmitButton questionListButton={true} ref={submitRef} caption='>' loading={false} />
            }
        </div>
    </>
}
